export default {"src":"/_next/static/media/HSBC_logo.926880b1.svg","height":85,"width":316,"blurWidth":0,"blurHeight":0};